import React, { useState, useEffect, createContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import CreatePackage from "./create/createPackage";
import UpdatePackage from "./update/updatePackage";
import axios from "axios";
import { API } from "../../../services/api";

axios.defaults.baseURL = API;
const PackageContext = createContext();

function Package() {

  const [dataList, setDataList] = useState([]);
  const [showData, setShowData] = useState([]);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleCloseUpdate = () => setShowUpdate(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Search = event => {
    const { value } = event.target;
    if(value){
      var results = [];
      results = dataList.filter((data) => {
          return data.PackageName.toLowerCase().includes(value.toLowerCase())
      });
      if (results) 
      setShowData(results);
      else 
      setShowData(dataList);
    } else 
    setShowData(dataList);
  }

  const openUpdate = (PackageID, PackageName, PackagePrice) => {
    var list = [];
    list.push({
      PackageID: PackageID,
      PackageName: PackageName,
      PackagePrice: PackagePrice,
    });
    setData(list);
    setShowUpdate(true);
  };

  async function getAllPackage() {
    axios
      .get("/getAllPackage")
      .then((response) => {
        let Data = response?.data;
        setDataList(Data);
        setShowData(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  
  useEffect(() => {
    getAllPackage();
  }, []);

  return (
    <PackageContext.Provider value={{dataList, setDataList, data, setShowData}}>
      <div className="formContent">
        <CreatePackage show={show} onClick={handleClose}/>
        <UpdatePackage show={showUpdate} onClick={handleCloseUpdate}/>
        <div className="Header">
          <div className="title">
              <span>ຂໍ້ມູນ Package</span>
          </div>
          <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາ" onChange={(e) => Search(e)} />
            <button className="btn btn-primary" onClick={handleShow} >ເພີ່ມ</button>
          </div>
        </div>
        <div className="Body">
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>ຊື່ Package</th>
                <th>ລາຄາ Package</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                showData && showData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.PackageName}</td>
                        <td >{x.PackagePrice}</td>
                        <td >
                          <button className="btn btn-secondary" value={x.PackageID} type="button" onClick={() => openUpdate(x.PackageID, x.PackageName, x.PackagePrice)}>ແກ້ໄຂ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </PackageContext.Provider>
  );
};

export {PackageContext};
export default Package;
